import { render, staticRenderFns } from "./addWarehouse.vue?vue&type=template&id=635e1bfc&scoped=true&"
import script from "./addWarehouse.vue?vue&type=script&lang=js&"
export * from "./addWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635e1bfc",
  null
  
)

export default component.exports